<template>
  <div>
    <div class="bigBox">
      <div class="logo">
        <router-link to="/">
          <img src="../../../assets/images/BaiDu02-logo.png" alt="">
        </router-link>
      </div>
      <div class="search">
        <input type="text">
        <input type="button" value="百度一下">
        <div class="img"></div>
      </div>
      <div class="rList">
        <router-link to="/">
          <div class="first">百度首页</div>
        </router-link>
        <div class="setting">
          <div class="set">设置</div>
          <ul class="setList">
            <li v-for="list in setArr">{{ list }}</li>
          </ul>
        </div>
        <div class="login">登录</div>

      </div>
    </div>
    <div class="nav01">
      <ul>
        <li v-for="list in nav01Arr" :key="list.id">
          <img :src="list.imgSrc" alt="">
          <span>{{ list.name }}</span>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
export default {
  name: "SearchBox02",
  data() {
    return {
      setArr: ['搜索设置', '高级搜索', '关闭预测', '隐私设置', '隐藏热搜'],
       nav01Arr:[
         {
           name: "网页",
           imgSrc: require('@/assets/images/放大镜.png')

         },
         { name:"图片",
           imgSrc:require('@/assets/images/图片.png')
         },
         { name:"资讯",
           imgSrc:require('@/assets/images/资讯.png')
         },
         { name:"视频",
           imgSrc:require('@/assets/images/视频.png')
         },
         { name:"笔记",
           imgSrc:require('@/assets/images/笔记，记录.png')
         },
         { name:"地图",
           imgSrc:require('@/assets/images/地图.png')
         },
         { name:"贴吧",
           imgSrc:require('@/assets/images/icon-tieBa.png')
         },
         { name:"文库",
           imgSrc:require('@/assets/images/文库.png')
         },
         { name:"更多"
         },
       ]
    }

  },
}
</script>

<style scoped lang="scss">
.bigBox {
  width: 1528px;
  height: 70px;
  //background: #42b983;
  display: flex;

  .logo img {
    width: 101px;
    height: 33px;
    margin-top: 15px;
    margin-left: 15px;
    position: relative;
  }

  .search {
    /*width: 603px;
    height: 40px;
    background: #315efb;*/
    margin-left: 20px;
    margin-top: 15px;
    position: relative;

    input:first-child {
      width: 550px;
      height: 38px;
      border-radius: 10px 0 0 10px;
      padding-right: 40px;
      padding-left: 15px;
      font-size: 15px;
      outline: none;
      border: 1px solid #c4c7ce;

    }

    input:nth-child(2) {
      width: 112px;
      height: 39px;
      background: #4e6ef2;
      color: white;
      border-radius: 0 10px 10px 0;
      margin-left: -1px;
      font-size: 17px;
      border: none;
      line-height: 38px;


    }

    .img {
      width: 26px;
      height: 26px;
      position: absolute;

      //background-color: #c27d54;
      top: 8px;
      right: 122px;
      background: url("@/assets/images/相机1.png");
      ///* background-size: 100%;*/
    }
  }

  .rList {
    width: 200px;
    height: 38px;
    //background: red;
    display: flex;
    position: relative;
    margin-left: 480px;
    margin-top: 28px;
    //line-height: 38px;
    text-align: center;
    color: black;
    font-size: 13px;
    display: flex;
    justify-content: space-between;

    .setList {
      width: 80px;
      height: 120px;
      display: none;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      /*background: #42b983;*/
      margin: 5px;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    }
  }



  li:hover, .first:hover, .set:hover, .login:hover {
    color: #315efb;
    cursor: pointer;
  }

  .setting:hover .setList {
    display: flex;
  }
}
.nav01{
  width: 600px;
  height: 50px;
  //background: #c27d54;
  margin-left: 128px;
  ul{
    width: 600px;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    li{
      color: #616162;
      span{
        cursor: pointer;
      }
    }
  }
}
</style>